// frontend/src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DetalheEmpreendimento from './pages/DetalheEmpreendimento'; 
import Mapa from './pages/Mapa';
import Edicao from './pages/Edicao';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes> {/* As rotas DEVEM estar dentro de Routes */}
          {/* Rota raiz (/) deve apontar para o Mapa */}
          <Route path="/" element={<Mapa />} /> 
          <Route path="/empreendimento/:id" element={<DetalheEmpreendimento />} />
          <Route path="/empreendimento/:id/editar" element={<Edicao />} />
          {/* Adicione uma rota 404 para capturar rotas inválidas, caso você não tenha criado uma rota default */}
          <Route path="*" element={<h1>404 | Página Não Encontrada</h1>} /> 
        </Routes>
      </div>
    </Router>
  );
}

export default App;